<template>
<div>
  <!-- View data modal template -->
  <b-modal ref="view-lb" hide-footer @hide="hideLBModal">
    <div class="d-block text-center">
      <h4 qid="update-tp-title">
        {{ $t('maintenance.retention_rules.view.title') }}
      </h4>
    </div>
    <b-alert v-if="error.length"
             show
             variant="danger"
             qid="create-p-error"
    >
      {{ error }}
    </b-alert>

    <label class="mt-3" v-if="object.retention_rule && object.retention_rule.name">
      {{ $t('maintenance.retention_rules.create.name_label') }}
    </label>
    <br>
    <span v-if="object.retention_rule && object.retention_rule.name">
      {{ object.retention_rule.name }}
    </span>
    <br>

    <label class="mt-3" v-if="object.retention_rule && object.retention_rule.time_limit">
      {{ $t('activities.retention_rule.table.time_limit') }}
    </label>
    <br>
    <span v-if="object.retention_rule && object.retention_rule.time_limit">
      {{ object.retention_rule.time_limit }}
    </span>
    <br>

    <label class="mt-3" v-if="object.retention_rule && object.retention_rule.description">
      {{ $t('maintenance.retention_rules.create.description_label') }}
    </label>
    <br>
    <span v-if="object.retention_rule && object.retention_rule.description" class="text-formatted">
      {{ object.retention_rule.description }}
    </span>
    <br>

    <div class="mt-3" v-if="object.retention_rule && object.retention_rule.media && object.retention_rule.media.length">
      <p class="text-dark">{{ $t('attachments.label') }}</p>
      <p v-for="(file, index) in object.retention_rule.media">
        <span class="mr-3 float-right text-muted cursor-pointer"
              @click="downloadMedia(file)"
              qid="download-media"
        >
          <font-awesome-icon icon="cloud-download-alt" />
        </span>
        <a @click="downloadMedia(file)" qid="create-tp-media-item">
          {{ file.file_name }}
        </a>
      </p>
      <br>
    </div>

    <div v-if="object.retention_rule && object.retention_rule.links && object.retention_rule.links.length">
      <p class="text-dark">{{ $t('links.label') }}</p>
      <div v-if="object.retention_rule.links">
        <p v-for="(link, index) in object.retention_rule.links" >
          <a :href="link.url" target="_blank" qid="create-tp-link-item">
            {{ link.name ? link.name : link.url }}
          </a>
        </p>
      </div>
      <br>
    </div>

    <b-button class="mt-4 float-right"
              variant="success"
              @click="hideLBModal"
              qid="create-p-cancel-button"
    >
      {{ $t('processes.legal_basis.view.close') }}
    </b-button>
    <br>

  </b-modal>

</div>

</template>

<script>
  import piincHttp from '@/util/configureAxios.js'

  export default {
    name: 'RetentionRuleViewModal',
    data: function() {
      return {
        inputLink: '',
        selectedArticle: [],
        articles: [],
        error: '',
        showInput: false,
        showSingleLinkLabel: true,
        loadingItems: false,
        showArticleDescription: false,
        selectedFileObject: {},
        selectedFileIndex: '',
        selectedLinkObject: {},
        selectedLinkIndex: '',
      }
    },
    props: {
      object: {
        type: [Object,Array]
      },
      showModal: {
        type: Boolean
      }
    },
    computed: {
      getClient() {
        return this.$store.state.client
      }
    },
    watch: {
      // Watch when prop changes
      showModal: function (value) {
        if (value) {
          this.showLBModal()
        }
      }
    },
    methods: {
      downloadMedia(object){
        piincHttp.get('documents/' + object.id + '/download', {responseType: 'blob'}).then(function(response) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.download = object.file_name;

          link.click();
          link.remove()
          window.URL.revokeObjectURL(url);
        }, function() {});
      },
      showLBModal() {
        let self = this
        this.$refs['view-lb'].show()
      },
      hideLBModal() {
        this.error = ''
        this.showArticleDescription = false;
        this.$emit('closeViewModal');
        this.$refs['view-lb'].hide()
      }
    },
    components: {

    },
    created () {

    }
  }
</script>
